import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import './PartnerDemoPages.css';

const DEMO_CERTS = [
  { id: 1, name: 'ISO 27001:2022', issuer: 'BSI', date: '2024-06-01' },
  { id: 2, name: 'SOC 2 Type II', issuer: 'A-LIGN', date: '2024-03-15' },
  { id: 3, name: 'QCB Compliance', issuer: 'Qatar Central Bank', date: '2025-01-10' },
];

export default function DemoPartnerCertifications() {
  return (
    <div className="partner-demo-page">
      <nav className="page-breadcrumb">
        <Link to="/">Home</Link>
        <span className="mx-2">/</span>
        <span>Certifications</span>
      </nav>
      <header className="page-header">
       
        <p className="page-subtitle mb-0">
          Certifications and attestations held by your organization. Keep validity dates up to date.
        </p>
      </header>

      <Row className="g-3">
        {DEMO_CERTS.map((c) => (
          <Col lg="4" md="6" key={c.id}>
            <div className="cert-card">
              <div className="cert-name">{c.name}</div>
              <div className="cert-detail"><strong>Issuer:</strong> {c.issuer}</div>
              <div className="cert-detail"><strong>Valid from:</strong> {c.date}</div>
              <button type="button" className="btn btn-partner-outline btn-sm mt-3">View details</button>
            </div>
          </Col>
        ))}
      </Row>
      <div className="mt-4">
        <Link to="/" className="btn btn-partner-outline">Back to dashboard</Link>
      </div>
    </div>
  );
}
